import BaseModel from './base_model';
import mapObjectPopup from '../templates/popups/map_object';
import parkingLotPopup from '../templates/popups/parking_lot';

export default class MapObject extends BaseModel {
	/**
	 * Represents a MapObject linked to the server API.
	 * @constructor
	 * @param {integer} map_object_id - The id of the Rails MapObject.
	 */
	constructor(map_object_id) {
		super();
		this.map_object_id = map_object_id;
		this.url = W.api_root + 'map_objects' + '/' + map_object_id + '.geojson';
		this.key = 'MapObject_' + map_object_id;
	}

	setHtmlView() {
		this.htmlView = W.api_root + 'map_objects/' + this.map_object_id + '.html';
	}

	title() {
		// Parking lots prefer description for title if one is available
		if (this.data.object_type === 'parking_lot') {
			return !this.data.description ? this.data.name : this.data.description;
		}
		return this.data.name;
	}

	/**
	 * Popup content
	 */
	popupContent() {
		this.setHtmlView();
		if (this.data.object_type === 'parking_lot') {
			this.hasRealtime = this.data.meta && this.data.meta.parking_api_uid;
			return parkingLotPopup(this);
		}
		return mapObjectPopup(this);
	}
}
